  
<template>
  <div class="ga-loading" v-if="isShowLoading">
     <div class="mask rule-mask loading-mask"></div>
      <img :src="loadingIcon"/>
    <div>{{content}}</div>
  </div>
</template>

<script>
import loadingIcon from '../../../static/pics/loading.svg'
  export default {
    data() {
      return {
        loadingIcon:loadingIcon,
        isShowLoading:false,
        content:''
      };
    }
  };
</script>
<style lang="scss">
.ga-loading{
    width: 100%;
    height:  100%;;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    img{
      width: 20vh;
      height: 20vh;
      position: fixed;
      top: 50%;
      left: 50%;
      margin-left: -10vh;
      margin-top: -10vh;
      z-index: 999;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/wsLoading/loading.vue